import { View, Text, TouchableOpacity, Switch } from "react-native";
import React, { useEffect, useState } from "react";
import { styles } from "../advanceFilterStyles";
import OptionsFilter from "../../filterComponents/OptionsFilter";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import { getUser } from "../../../../../services/ProfileSettings/ProfileSettingService";

export default function FilterItemAdvance({
  label,
  value,
  switch: isSwitch,
  type,
  component,
  name,
  filters,
  filter,
  setFilters,
  handlePress,
  isEnabled,
  setIsEnabled,
  multiselect,
  advanced,
}: {
  filter: any;
  label: string;
  value: string;
  switch: boolean;
  type?: string;
  component?: any;
  name: string;
  filters: any;
  setFilters: any;
  handlePress: (
    label: string,
    value: string,
    component: any,
    name: any,
    filters: any,
    setFilters: any
  ) => void;
  isEnabled: boolean;
  setIsEnabled: any;
  multiselect?: boolean;
  advanced?: boolean;
}) {
  const [isUserSubscribed, setIsUserSubscribed] = useState(false);
  const toggleSwitch = () => {
    setIsEnabled((previousState: any) => !previousState);
    setFilters((prev: any) => ({
      ...prev,
      advanceFilters: {
        ...prev.advanceFilters,
        isVerified: isEnabled ? "false" : "true",
      },
    }));
  };
  useEffect(() => {
    getUser().then((data) => {
      console.log(data?.data?.isSubscribed);
      if (data?.data?.isSubscribed) {
        setIsUserSubscribed(true);
      }
    });
  }, []);
  return (
    <TouchableOpacity
      style={styles.FilterItem}
      onPress={() => {
        if (isSwitch) {
          toggleSwitch();
          setFilters((prev: any) => ({
            ...prev,
            advanceFilters: {
              ...prev.advanceFilters,
              isVerified: isEnabled ? "false" : "true",
            },
          }));
        } else if (type === "optionFilter") {
          handlePress(
            label,
            value,
            <OptionsFilter
              options={filter.options}
              name={name}
              filters={filters}
              setFilters={setFilters}
              multiselect={multiselect}
              advanced={advanced}
            />,
            name,
            filters,
            setFilters
          );
        } else {
          handlePress(label, value, component, name, filters, setFilters);
        }
      }}
    >
      <View>
        <Text style={GlobalStyles.bodyText}>{label}</Text>
        {value && !isSwitch && (
          <Text style={[GlobalStyles.bodyText, { opacity: 0.4, marginTop: 4 }]}>
            {value}
          </Text>
        )}
      </View>
      <View style={styles.FilterRight}>
        {isSwitch && (
          <Switch
            trackColor={{
              true: "#EEE6D8",
              false: "black",
            }}
            thumbColor={isEnabled ? "#C0A46F" : "#FDFBF9"}
            onValueChange={toggleSwitch}
            value={isEnabled}
            style={{ transform: [{ scale: 0.8 }] }}
          />
        )}
        {/* {} */}
        {!isUserSubscribed && <FeedIcons.Lock />}
      </View>
    </TouchableOpacity>
  );
}
